export const normalizeCommanderOption = (commander, allianceNameById = {}) => {
  const commanderId = String(commander?._id || commander?.id || "");
  if (!commanderId) return null;

  const allianceId = String(commander?.alliance?._id || commander?.alliance || "");
  const allianceLabel =
    allianceNameById[allianceId] ||
    commander?.alliance?.acronym ||
    commander?.alliance?.name ||
    "Unknown";

  return {
    value: commanderId,
    label: `${commander?.name || commanderId} (${allianceLabel})`,
    commanderName: commander?.name || commanderId,
    allianceId,
    allianceLabel,
    battlePower: Number(commander?.battlePower || 0),
    cityLevel: commander?.cityLevel ?? null,
    nationId: String(commander?.nation?._id || commander?.nation || ""),
    raw: commander,
  };
};

export const filterCommanderOptions = (options, query) => {
  const needle = String(query || "").trim().toLowerCase();
  if (!needle) return options;

  return (options || []).filter((option) => {
    const hay = `${option?.commanderName || ""} ${option?.allianceLabel || ""} ${option?.label || ""}`.toLowerCase();
    return hay.includes(needle);
  });
};

export const findExactCommanderMatch = (options, query) => {
  const needle = String(query || "").trim().toLowerCase();
  if (!needle) return null;

  const exact = (options || []).filter((option) => {
    const name = String(option?.commanderName || "").trim().toLowerCase();
    const label = String(option?.label || "").trim().toLowerCase();
    return name === needle || label === needle;
  });

  return exact.length === 1 ? exact[0] : null;
};
